
module.exports = {
  AdminPageHeader: require('./components/AdminPageHeader'),
  AdminTitle: require('./components/AdminTitle'),
  AdminSubtitle: require('./components/AdminSubtitle'),
  SecondLayerMenu: require('./components/SecondLayerMenu'),
  ThirdLayerMenu: require('./components/ThirdLayerMenu'),
  AdminCard: require('./components/AdminCard'),
  AdminDetailsRow: require('./components/AdminDetailsRow').default,
  AdminDetailsCol: require('./components/AdminDetailsCol').default,
  AdminDetailsItem: require('./components/AdminDetailsItem').default,
  AdminFormRow: require('./components/AdminFormRow'),
  AdminFormCol: require('./components/AdminFormCol'),
  AdminUserDataLayout: require('./components/AdminUserDataLayout'),
}
